module.exports = __webpack_public_path__ + "static/img/service.5fe4fce1.svg";